import React, { useState, useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import type { Stripe } from '@stripe/stripe-js';
import { useLocation } from 'react-router-dom';

interface StripeProviderProps {
  children: React.ReactNode;
}

// Lazy Stripe provider: only loads the Stripe SDK when the checkout/payment page is visited
export const StripeProvider: React.FC<StripeProviderProps> = ({ children }) => {
  const [stripe, setStripe] = useState<Stripe | null>(null);
  const location = useLocation();

  const needsStripe = location.pathname.includes('checkout') || location.pathname.includes('payment');

  useEffect(() => {
    if (!needsStripe) return;
    import('@/lib/stripe').then(mod => {
      mod.getStripe().then(setStripe);
    });
  }, [needsStripe]);

  if (needsStripe) {
    if (!stripe) {
      // Show loader while Stripe SDK loads
      return (
        <div className="flex items-center justify-center" style={{ minHeight: '60vh' }}>
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        </div>
      );
    }
    return (
      <Elements stripe={stripe}>
        {children}
      </Elements>
    );
  }

  return <>{children}</>;
};
